var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C10.3212 46 0 35.6811 0 23.0051C0 10.329 10.311 0 23 0C35.6788 0 46 10.3189 46 22.9949C46 35.671 35.6788 46 23 46ZM23 1.50737C11.1509 1.50737 1.5077 11.1484 1.5077 22.9949C1.5077 34.8414 11.1509 44.4825 23 44.4825C34.8491 44.4825 44.4923 34.8414 44.4923 22.9949C44.4923 11.1484 34.8491 1.50737 23 1.50737Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6683 18.4119C29.6177 18.4119 29.5773 18.422 29.5368 18.4422V17.6531C29.5368 16.1963 28.3529 15.0127 26.8958 15.0127H18.4769C17.0198 15.0127 15.8359 16.1963 15.8359 17.6531V28.1541C15.8359 29.6109 17.0198 30.7945 18.4769 30.7945H26.8958C28.3529 30.7945 29.5368 29.6109 29.5368 28.1541V27.4763C29.5469 27.4763 29.5469 27.4864 29.557 27.4864C29.6481 27.4864 29.729 27.4156 29.729 27.3144V23.1666C29.729 23.0756 29.6582 22.9947 29.557 22.9947C29.5469 22.9947 29.5469 23.0048 29.5368 23.0048V21.4468C29.5773 21.4569 29.6177 21.4772 29.6683 21.4772C29.9415 21.4772 30.154 21.2546 30.154 20.9916V18.9076C30.154 18.6344 29.9314 18.4119 29.6683 18.4119Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0287 13.6166H17.2725L17.829 10.2882C17.9808 9.3575 18.7903 8.67969 19.7212 8.67969H25.5699C26.5109 8.67969 27.3103 9.3575 27.4621 10.2882L28.0287 13.6166Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0288 32.1904H17.2726L17.8291 35.5188C17.9809 36.4495 18.7904 37.1273 19.7213 37.1273H25.57C26.511 37.1273 27.3104 36.4495 27.4622 35.5188L28.0288 32.1904Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwatch);
export default __webpack_public_path__ + "static/media/iwatch.38345242dc7b4bfd589e872b999b0020.svg";
export { ForwardRef as ReactComponent };